import { useRef, useState, useEffect, createRef, useMemo } from 'react'
import {
    Box, Button, ButtonGroup, Flex, HStack, IconButton, Input, SkeletonText, Text, Stack, VStack,
    Drawer, DrawerBody, DrawerFooter, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton,
    useDisclosure, WrapItem, Avatar, Select, Divider,
    Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalHeader, ModalBody, ModalFooter, FormControl,
    FormLabel, FormErrorMessage, useToast
} from '@chakra-ui/react'
import { FaLocationArrow, FaTimes, FaRocketchat, FaSearch, FaCar, FaMobile, FaPlus, FaGripVertical, FaCheckCircle } from 'react-icons/fa'

import {
    useJsApiLoader, GoogleMap, Marker, InfoWindow, Autocomplete, DirectionsRenderer,
    Polyline
} from '@react-google-maps/api'

import {
    DragDropContext,
    Droppable,
    Draggable
} from '@hello-pangea/dnd';

import UserService from '../../services/UserService';
import DriverService from '../../services/DriverService';
import CommonService from '../../services/CommonService';
import { io } from "socket.io-client";
import config from '../../constants/config';
import { calculateAge, getGender, getMusic, moveDriverOnPolyline } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import DriverLayout from '../../layouts/DriverLayout';
import { getDistanceInKm, getLatLng, checkUserOnRoute } from '../../utils/driverUtils';
import { clearDriverRideData, getDriverRideDataFromStorage, setDriverRideDataInStorage } from '../../utils/localStorage';
import { selectCandelRideData, selectCandelRideLoading, setCancelRideData } from '../../store/features/cancelRideSlice';
import { useDispatch, useSelector } from 'react-redux';
import DriverRatingModal from './DriverRatingModal';
import PassengerRatingModal from '../user/PassengerRatingModal';
import RouteMarkers from '../../components/RouteMarkers';
import RemainingRoute from '../../components/RemainingRoute';
import RefreshPageButton from '../../components/RefreshPageButton';
import { findMatchingPassengers } from '../../utils/passengerMatching';
import { getSeatCapacity, getSideBySideOffsets, limitPassengersToSeats } from '../../utils/markerLayout';
import {
    getTestModeGeolocation, hasTestModeTriggerMessage, isTestModeAvailable, isTestModeWatchId, markTestModeRideAccepted,
    logTestModeChatCheck, testModeLog, getTestModeChatMsgId,
} from '../../testMode/testModeGpsSimulatorService';

// const center = {
//     lat: 19.0760,
//     lng: 72.8777
// };

// Outside your component
const libraries = ['places', 'geometry']; // add more libraries if needed

function DriverMapWithDirections() {
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries,
    })

    const backendUrl = config.apiBaseUrl;
    //const socket = io(`${config.apiBaseUrl}`); // Backend server URL
    const user = JSON.parse(localStorage.getItem("user"));
    const driverRideSession = getDriverRideDataFromStorage()
    const socketRef = useRef(null);
    const watchIdRef = useRef(null);
    const latestLocationRef = useRef(null);
    const locationSyncIntervalRef = useRef(null);
    const rideStartRequestRef = useRef(0);
    const passengersRequestRef = useRef(0);
    const passengerInfoRefData = useRef(null)
    // testMode: latest selected ride route, read by the GPS simulator (no-op when testMode is off).
    const testModeRideRouteRef = useRef(null);
    // Real navigator.geolocation unless testMode is on and this ride's chat has MsgId 15.
    const testModeGeolocation = getTestModeGeolocation(() => testModeRideRouteRef.current);
    const dispatch = useDispatch();

    const candelRideState = useSelector(selectCandelRideData)

    const toast = useToast();

    const [map, setMap] = useState((null))
    const [center, setCenter] = useState({ lat: 19.0760, lng: 72.8777 });
    const [directionsResponse, setDirectionsResponse] = useState(null)
    const [distance, setDistance] = useState('')
    const [duration, setDuration] = useState('')
    const [selectedRouteIndex, setSelectedRouteIndex] = useState(0)
    const [users, setUsers] = useState([]);
    const [passengerCandidates, setPassengerCandidates] = useState([]);
    const [onboardRequests, setOnboardRequests] = useState([]);

    const [nearestUser, setNearestUser] = useState(null);
    const [driverLocation, setDriverLocation] = useState(null);
    const [DriveNo, setDriveNo] = useState(0);
    // Per-passenger (ReqNo) pick-up / drop-off notices, persisted across refresh.
    const [pickupReachedReqs, setPickupReachedReqs] = useState(() => getDriverRideDataFromStorage().pickupReachedReqs || []);
    const [dropReachedReqs, setDropReachedReqs] = useState(() => getDriverRideDataFromStorage().dropReachedReqs || []);

    const [driverRoute, setDriverRoute] = useState('')
    const [driver, setDriver] = useState('')

    const [passengerMarker, setPassengerMarker] = useState('')
    const [driverMarker, setDriverMarker] = useState('')
    const [passengerInfo, setPassengerInfo] = useState({
        uId: null,
        Name: null,
        MobileNo: null,
        ReqNo: null,
    });

    const [messages, setMessages] = useState([])
    const [reply, setReply] = useState([])
    const [amount, setAmount] = useState(0);
    const [otp, setOTP] = useState(0);
    const [selectedOTPPassenger, setSelectedOTPPassenger] = useState(null);
    const [otpError, setOTPError] = useState(null);
    const [vehicleList, setVehicleList] = useState([])
    const [searchSection, setSearchSection] = useState(true)
    const [driveBtn, setDriveBtn] = useState(false);

    const [vehicleDvNo, setVehicleDvNo] = useState(0)
    const [vehicleType, setVehicleType] = useState(0)
    const [origin, setOrigin] = useState("");
    const [destination, setDestination] = useState("");
    const [waypoints, setWaypoints] = useState([]);
    const [localWaypointValues, setLocalWaypointValues] = useState(waypoints);

    const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);

    const [routeColor, setRouteColor] = useState("blue");

    const waypointRefs = useRef([]);
    const originRef = useRef(null);
    const destinationRef = useRef(null);

    const { isOpen, onOpen, onClose } = useDisclosure()
    const btnRef = useRef()

    const selectedDirections = useMemo(() => {
        if (!directionsResponse) return null;

        return {
            ...directionsResponse,
            routes: [directionsResponse.routes[selectedRouteIndex]],
        };
    }, [directionsResponse, selectedRouteIndex]);

    const navigate = useNavigate();

    const {
        isOpen: isModalOpen,
        onOpen: onModalOpen,
        onClose: onModalClose,
    } = useDisclosure();

    // lat: 21.2284082,
    // lng: 81.4495937
    // charouda

    const getChats = async (driveNo, PassengerId, callFrom = "") => {
        const chats = await CommonService.getChating(driveNo, PassengerId);
        setMessages(chats);
    };

    const driverReply = async (driveNo, PassengerId) => {
        let params = {};
        params.DriveNo = driveNo;
        params.PassengerId = PassengerId;
        if (driveNo > 0) {
            const rply = await DriverService.getDriverReply(params);
            setReply(rply)
        }
    };

    useEffect(() => {
        let cancelled = false;
        const runKycFlow = async () => {
            const isKycPassed = await kycTest();
            if (isKycPassed && !cancelled) {
                if (driverRideSession.DriveNo > 0) {
                    const restoredRide = await routeCreate();
                    const trackingComplete = driverRideSession.trackingComplete || Number(restoredRide?.Stat) === 5;
                    if (trackingComplete) {
                        setDriverRideDataInStorage({ trackingComplete: true });
                    } else {
                        startLocationTracking();
                        startLocationSync(driverRideSession.DriveNo);
                    }
                }
                getCurrentOrigin();
                getVehicleList();

                setLocalWaypointValues(waypoints);

                // if (waypoints.length > 0) {
                //     calculateRoute()
                // }

                // socket.connect();
                // console.log("Connected to WebSocket");

                // socket.on("receive_message", (msg) => {
                //     console.log("Received:", msg);
                //     getChats(DriveNo, passengerInfo.uId);
                //     driverReply(DriveNo, passengerInfo.uId);
                //     if (origin && destination && vehicleDvNo) {
                //         calculateRoute();
                //     }
                //     travelingUsers(DriveNo);
                // });

                // const interval = setInterval(getCurrentLocation, 60000);

                // // Cleanup on unmount
                // return () => {

                //     navigator.geolocation.clearWatch(interval);

                //     socket.off("receive_message");
                //     socket.disconnect();
                // };
            }
        };

        runKycFlow();
        return () => { cancelled = true; };
    }, [DriveNo]);

    useEffect(() => {
        // Restore passengers independently of Directions/Geocoding completion.
        if (DriveNo > 0) travelingUsers(DriveNo);
        return () => { passengersRequestRef.current++; };
    }, [DriveNo]);

    useEffect(() => {
        let cancelled = false;
        const onboardIds = new Set(onboardRequests);
        const onboard = passengerCandidates.filter(passenger => onboardIds.has(String(passenger.ReqNo)));
        // Only passengers already onboard bypass discovery checks, never all
        // candidates just because another passenger's ride has started.
        setUsers(onboard);
        const route = selectedDirections?.routes[0];
        if (isLoaded && driver && route?.overview_path?.length) {
            const path = route.overview_path.map(point => ({ lat: point.lat(), lng: point.lng() }));
            const candidates = passengerCandidates.filter(passenger => !onboardIds.has(String(passenger.ReqNo)));
            findMatchingPassengers(candidates, driver, path).then(matches => {
                if (!cancelled) setUsers([...onboard, ...matches]);
            });
        }
        return () => { cancelled = true; };
    }, [passengerCandidates, onboardRequests, selectedDirections, driver, isLoaded]);

    useEffect(() => {
        const requestId = ++rideStartRequestRef.current;
        let cancelled = false;
        if (DriveNo > 0) {
            // A DriveNo exists as soon as the drive is posted. Only onboard
            // passengers (drivedet.Stat = 1) confirm a ride started via OTP.
            DriverService.getPassengerByDriveNo({
                DriveNo,
                uId: user.uId,
                authToken: user.authToken,
            }).then(response => {
                if (!cancelled && requestId === rideStartRequestRef.current && response.statusCode === 200) {
                    const onboard = response.data.filter(passenger => Number(passenger.Stat) === 1);
                    setOnboardRequests(onboard.map(passenger => String(passenger.ReqNo)));
                    if (isTestModeAvailable() && onboard.length) testModeCheckRideAcceptedChats(DriveNo, onboard);
                }
            }).catch(error => console.error('Error restoring ride start status:', error));
        } else {
            setOnboardRequests([]);
        }
        return () => { cancelled = true; };
    }, [DriveNo, user.uId, user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (waypoints.length > 0) {
            calculateRoute();
        }
    }, [waypoints]);

    useEffect(() => {
        if (candelRideState == "cancel-by-driver") {
            handleCancelRideByDriver()
        }
    }, [candelRideState]);

    const handleCancelRideByDriver = async () => {
        try {
            for (const passenger of users) {
                const params = {
                    DriveNo,
                    DriverId: user.uId,
                    uId: passenger.PassengerId,
                    MsgId: 28,
                    Rate: 0,
                    msg: "Driver Cancels Ride",
                    DStat: 0,
                    PStat: 0,
                    SendBy: user.uId,
                    MobileNo: passenger.MobileNo,
                    ReqNo: passenger.ReqNo,
                    authToken: user.authToken,
                };
                // Save passenger reply
                await UserService.savePassengerReply(params);
                // Send socket message
                socketRef.current.emit("send_message", {
                    senderId: user.uId,
                    receiverId: passenger.PassengerId,
                    messageData: {
                        MsgId: 28,
                        msg: "Driver Cancels Ride",
                        ReqNo: passenger.ReqNo,
                    },
                });
            }
            dispatch(setCancelRideData("cancel-by-driver"));
            clearRoute()
            navigate(0);
        } catch (error) {
            console.error("Error cancelling ride:", error);
        }
    };


    // =========================
    // SOCKET INITIALIZATION
    // =========================

    const initializeSocket = () => {

        if (socketRef.current) return;

        socketRef.current = io(config.socketUrl, {
            path: config.socketPath
        });

        socketRef.current.on("connect", () => {
            console.log("Socket Connected");
            // Register current user
            socketRef.current.emit("register", user.uId);
            publishDriverLocation();
        });

        socketRef.current.on("receive_message", (msg) => {
            console.log("Driver log---", "Received:", msg);
            // socket listeners only remember the state that existed/initial value when they were registered. If you need current data, fetch/read the latest value inside the callback.
            const latestRideSession = getDriverRideDataFromStorage();
            const currentPassengerInfo = passengerInfoRefData.current;
            const messageData = msg?.messageData || {};
            const sameRide = !messageData.DriveNo ||
                String(messageData.DriveNo) === String(latestRideSession.DriveNo);
            const samePassenger = !latestRideSession.PassengerId ||
                String(msg?.senderId) === String(latestRideSession.PassengerId);

            // MsgId 24 means the passenger has paid. Stop tracking immediately;
            // MsgId 25 remains available for the driver's receipt confirmation.
            const identifiesCurrentRide = messageData.DriveNo ? sameRide : samePassenger;
            if (Number(messageData.MsgId) === 24 && identifiesCurrentRide) {
                clearIntervalAction();
                setDriverRideDataInStorage({ trackingComplete: true });
            }

            if (currentPassengerInfo?.uId) {
                getChats(latestRideSession.DriveNo, currentPassengerInfo.uId, "socket call getChats"); // sender is passenger
                driverReply(latestRideSession.DriveNo, currentPassengerInfo.uId); // sender is passenger
            }

            if (origin && destination && vehicleDvNo) {
                calculateRoute();
            }

            travelingUsers(latestRideSession.DriveNo);
        });
        socketRef.current.on("connect_error", (err) => {
            console.error("CONNECT ERROR", err);
        });
    };

    useEffect(() => {
        passengerInfoRefData.current = passengerInfo;
    }, [passengerInfo]);

    useEffect(() => {
        testModeRideRouteRef.current = directionsResponse?.routes?.[selectedRouteIndex ?? 0] || null;
    }, [directionsResponse, selectedRouteIndex]);

    // testMode: MsgId 15 ("Ride accepted (OTP)") seen in this ride's chat -> start the simulator.
    useEffect(() => {
        if (!isTestModeAvailable() || !messages?.length) return;
        logTestModeChatCheck('driver chat window', messages);
        if (hasTestModeTriggerMessage(messages)) {
            const testModePassenger = users.find(passenger =>
                String(passenger.PassengerId) === String(passengerInfoRefData.current?.uId));
            testModeHandleRideAccepted(testModePassenger, 'driver chat window');
        }
    }, [messages]); // eslint-disable-line react-hooks/exhaustive-deps

    // Console helper: testModeStartGps() forces the simulator for the active ride.
    useEffect(() => {
        if (!isTestModeAvailable()) return undefined;
        window.testModeStartGps = () => testModeHandleRideAccepted(null, 'manual testModeStartGps()');
        return () => { delete window.testModeStartGps; };
    });

    // =========================
    // START GPS TRACKING
    // =========================

    const startLocationTracking = () => {

        if (getDriverRideDataFromStorage().trackingComplete) return;

        // prevent multiple watchers
        if (watchIdRef.current !== null) {
            console.log(
                "Location tracking already running"
            );
            return;
        }

        if (!testModeGeolocation) {
            alert(
                "Geolocation is not supported"
            );
            return;
        }

        watchIdRef.current =
            testModeGeolocation.watchPosition(

                (position) => {

                    const { latitude, longitude } = position.coords;
                    const location = {
                        lat: latitude,
                        lng: longitude,
                    };

                    // Ignore late callbacks after cancellation or completion.
                    const activeSession = getDriverRideDataFromStorage();
                    if (!activeSession.DriveNo || activeSession.trackingComplete || watchIdRef.current === null) return;
                    latestLocationRef.current = location;
                    setDriverLocation(location);
                    publishDriverLocation();
                    // Start interval only once
                    if (
                        activeSession.DriveNo > 0 &&
                        !locationSyncIntervalRef.current
                    ) {
                        startLocationSync(activeSession.DriveNo);
                    }

                    // console.log("GPS Updated from watchPosition :", location);
                },

                (err) => {
                    console.error("GPS Error:", err);
                },

                {
                    enableHighAccuracy: true,
                    maximumAge: 0,
                    timeout: 15000,
                }
            );
    };

    // =========================
    // TEST MODE: MsgId 15 -> swap real GPS for the simulator
    // =========================

    const testModeHandleRideAccepted = (testModePickup, testModeSource = 'unknown') => {
        if (!markTestModeRideAccepted(testModePickup, testModeSource)) return;
        if (isTestModeWatchId(watchIdRef.current)) {
            testModeLog(`simulator already running for this ride (${watchIdRef.current}); trigger from ${testModeSource} ignored`);
            return;
        }
        if (watchIdRef.current !== null) {
            testModeLog(`stopping REAL GPS watcher (${watchIdRef.current}) and switching to the simulator`);
            testModeGeolocation.clearWatch(watchIdRef.current);
            watchIdRef.current = null;
        }
        startLocationTracking();
    };

    // Refresh restore: look for MsgId 15 in the onboard passengers' chats.
    const testModeCheckRideAcceptedChats = async (testModeDriveNo, testModeOnboard) => {
        testModeLog(`refresh restore: checking chats of ${testModeOnboard.length} onboard passenger(s) for DriveNo ${testModeDriveNo}`);
        for (const testModePassenger of testModeOnboard) {
            const testModePassengerId = testModePassenger.PassengerId ?? testModePassenger.uId;
            if (testModePassengerId == null) continue;
            try {
                const testModeChats = await CommonService.getChating(testModeDriveNo, testModePassengerId);
                if (String(getDriverRideDataFromStorage().DriveNo) !== String(testModeDriveNo)) return;
                logTestModeChatCheck(`refresh restore, passenger ${testModePassengerId}`, testModeChats);
                if (hasTestModeTriggerMessage(testModeChats)) {
                    testModeHandleRideAccepted(testModePassenger, 'refresh restore (chat)');
                    return;
                }
            } catch (testModeError) {
                console.error('[testMode GPS] chat check failed', testModeError);
            }
        }
    };

    // =========================
    // START LOCATION UPDATES
    // TO SERVER EVERY 1 MINUTE
    // =========================

    const publishDriverLocation = () => {
        const { DriveNo: driveNo, trackingComplete } = getDriverRideDataFromStorage();
        // Do not queue old GPS fixes while offline. Send the latest on reconnect.
        if (driveNo && !trackingComplete && latestLocationRef.current && socketRef.current?.connected) {
            socketRef.current.emit("driverLocation", {
                DriveNo: driveNo,
                location: latestLocationRef.current,
            });
        }
    };

    const startLocationSync = (value) => {
        const currentSession = getDriverRideDataFromStorage();
        const driveNo = value || currentSession.DriveNo;
        if (!driveNo || currentSession.trackingComplete) return;
        // prevent duplicate intervals
        if (locationSyncIntervalRef.current) {
            console.log("interval get clear")
            clearInterval(locationSyncIntervalRef.current);
            locationSyncIntervalRef.current = null;
        }

        locationSyncIntervalRef.current =
            setInterval(() => {

                const location = latestLocationRef.current;

                if (!location) return;

                console.log("Sending Location:", location);

                // SOCKET UPDATE
                publishDriverLocation();

                // DATABASE/API UPDATE
                sendLocationToServer(
                    driveNo,
                    location.lat,
                    location.lng
                );

                console.log("Location sent to DB");

                // nearby passenger check
                if (users.length > 0) {

                    const maxDistanceMeters =
                        user.DropPointInMeter || 1000;

                    getMatchingRichDropPoint(
                        location,
                        users,
                        maxDistanceMeters
                    );
                }

            }, 60000);
    };

    // =========================
    // CLEANUP
    // =========================
    const stopTrackingAndSocket = () => {

        clearIntervalAction()

        // disconnect socket
        if (socketRef.current) {
            socketRef.current.off("receive_message");
            socketRef.current.disconnect();

            socketRef.current = null;
        }
    };

    const clearIntervalAction = () => {
        // STOP INTERVAL
        if (locationSyncIntervalRef?.current) {
            clearInterval(locationSyncIntervalRef.current);
            locationSyncIntervalRef.current = null;
        }
        // STOP GPS WATCHER
        if (watchIdRef.current !== null) {
            testModeGeolocation.clearWatch(watchIdRef.current);
            watchIdRef.current = null;
        }
        latestLocationRef.current = null;
    }

    const completeDriverRide = () => {
        clearIntervalAction()
        // OPTIONAL SOCKET DISCONNECT
        socketRef.current?.emit(
            "rideCompleted",
            {
                DriveNo
            }
        );
        console.log("Tracking Stopped");
    };

    useEffect(() => {
        initializeSocket();
        return () => {
            stopTrackingAndSocket();
        };
    }, []);

    const kycTest = async () => {
        const params = {
            uId: user.uId,
            authToken: user.authToken
        };
        try {
            const res = await CommonService.checkKYC(params);
            if (res.statusCode === 200) {
                if (res.data.kycStat === 5 && res.data.compStat === 5 && res.data.vehicleStat === 5) {
                    return true;
                } else {
                    navigate("/driver/kyc");
                    return false;
                }
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return false;
        }
    };

    const getCurrentOrigin = async () => {
        let params = { uId: user.uId }
        try {
            const res = await DriverService.getCurrentFullAddress(params)
            if (res.statusCode === 200) {
                if (origin == "") {
                    setOrigin(res.data.location)
                }
                setCenter({ lat: res.data.lat, lng: res.data.lng })
            }
        } catch (error) {
            if (error.response?.status === 401) {
                alert(error.response.data.message);
                // setotpErrors(error.response.data.message)
            } else {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        }
    }

    const routeCreate = async () => {
        try {
            const res = await DriverService.getCurrentRouteDetail(driverRideSession.DriveNo);
            if (res.statusCode === 200) {
                if (res.data.length > 0) {

                    setOrigin(res.data[0].Frmloc)
                    setDestination(res.data[0].Toloc)
                    setVehicleDvNo(res.data[0].DVNo)
                    setVehicleType(res.data[0].VTyp)
                    setDriveNo(driverRideSession.DriveNo)

                    setDriverLocation(latestLocationRef.current || { lat: res.data[0].lat, lng: res.data[0].lng })

                    calculateRouteWithParam(res.data[0].Frmloc, res.data[0].Toloc, res.data[0].DVNo);
                    setRouteColor("green");
                    return res.data[0];
                }
            }
        } catch (error) {

            if (error.response?.status === 401) {
                alert(error.response.data.message);
                // setotpErrors(error.response.data.message)
            } else {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        }
        return null;
    }

    const getVehicleList = async () => {
        const res = await DriverService.getApprovedVehicleList(user.uId);

        if (res.statusCode == 200) {
            setVehicleList(res.data)
        }
    }

    const getCurrentLocation = () => {
        // this function called when driver start driving
        if (!navigator.geolocation) {
            alert('Geolocation is not supported by your browser')
            return;
        }

        // navigator.geolocation.getCurrentPosition(
        //     (position) => {
        //         const { latitude, longitude } = position.coords;
        //         setDriverLocation({ lat: latitude, lng: longitude });
        //         if (DriveNo > 0) {
        //             // Optional: send location to backend here (for passengers)
        //             sendLocationToServer(DriveNo, latitude, longitude);
        //             if (users) {
        //                 const driverPos = { lat: latitude, lng: longitude };
        //                 const maxDistanceMeters = 1000;
        //                 getMatchingRichDropPoint(driverPos, users, maxDistanceMeters);
        //             }
        //         }
        //     },
        //     (err) => {
        //         console.error("Error getting position:", err);
        //     },
        //     {
        //         enableHighAccuracy: true,
        //     }
        // );

        // const watchId = navigator.geolocation.watchPosition(
        //     (position) => {
        //         const { latitude, longitude } = position.coords;

        //         const location = {
        //             lat: latitude,
        //             lng: longitude,
        //         };

        //         setDriverLocation({ lat: latitude, lng: longitude });
        //         if (DriveNo > 0) {
        //             // Optional: send location to backend here (for passengers)
        //             sendLocationToServer(DriveNo, latitude, longitude);
        //             if (users.length > 0) {
        //                 const driverPos = { lat: latitude, lng: longitude };
        //                 const maxDistanceMeters = user.DropPointInMeter || 1000; // 50 meter
        //                 getMatchingRichDropPoint(driverPos, users, maxDistanceMeters);
        //             }

        //             setCenter({ lat: location.lat, lng: location.lng });
        //              socket.emit('driverLocation', { DriveNo: DriveNo, location });
        //         }

        //     },
        //     (err) => console.error(err),
        //     { enableHighAccuracy: true }
        // );
        // return watchId;
    };

    const handleVehicle = (e) => {
        const dvNo = e.target.value === "" ? "" : Number(e.target.value);
        setVehicleDvNo(dvNo);
        // pull the data-type off the selected <option>
        const idx = e.target.selectedIndex;
        const opt = e.target.options[idx];

        setVehicleType(opt.getAttribute("data-type") || "");
    }

    const handleOrigin = () => {
        const place = originRef.current.getPlace();
        if (place && place.formatted_address) {
            setOrigin(place.formatted_address);
        } else {
            setOrigin("")
        }
    };

    const handleDestination = () => {
        const place = destinationRef.current.getPlace();
        if (place && place.formatted_address) {
            setDestination(place.formatted_address);
        } else {
            setDestination("")
        }
    };

    const sendLocationToServer = async (DriveNo, lat, lng) => {

        let params = {
            lat: lat,
            lng: lng,
            DriveNo: DriveNo,
            endLat: 0,
            endLng: 0,
            PassengerId: 0,
            uId: user.uId,
            authToken: user.authToken
        };
        if (DriveNo) {
            try {
                await DriverService.updateDriverCurrentLocation(params);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        }
    }

    const travelingUsers = async (DriveNo) => {
        const requestId = ++passengersRequestRef.current;
        let params = {
            DriverId: user.uId,
            DriveNo: DriveNo,
            authToken: user.authToken,
            CompCd: user.CompCd,
            role: user.role
        };
        if (DriveNo) {
            try {
                const passenger = await UserService.getTravelingUsers(params);

                // Fetch candidates only; the matching effect decides visibility
                // once the selected route and driver coordinates are ready.
                if (requestId === passengersRequestRef.current && Array.isArray(passenger)) {
                    setPassengerCandidates(passenger);
                }
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        }
    };

    if (!isLoaded) {
        return <SkeletonText />
    }

    // drga n drop waypoints
    const addWaypoint = () => {
        setWaypoints([...waypoints, '']);
        waypointRefs.current.push(createRef());
    };

    const removeWaypoint = (index) => {
        if (waypoints.length === 1) {
            setWaypoints([]); // ✅ Clear the array properly
            waypointRefs.current = [];
            setLocalWaypointValues([]);

            console.log(`Last waypoint removed ${waypoints}, ${index}`);
            calculateRoute()
        } else {
            const updatedWaypoints = waypoints.filter((_, i) => i !== index);
            setWaypoints(updatedWaypoints);
            waypointRefs.current = waypointRefs.current.filter((_, i) => i !== index);
        }

    };

    const updateWaypoint = (index, value) => {
        const newWaypoints = [...waypoints];
        newWaypoints[index] = value;
        setWaypoints(newWaypoints);
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const reordered = Array.from(waypoints);
        const [movedItem] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, movedItem);
        setWaypoints(reordered); // ✅ This triggers re-render and map update
        console.log(`rr ${reordered}`);

        // Also reorder refs (optional)
        const refCopy = Array.from(waypointRefs.current);
        const [movedRef] = refCopy.splice(result.source.index, 1);
        refCopy.splice(result.destination.index, 0, movedRef);
        waypointRefs.current = refCopy;

    };

    const handleInputChange = (index, value) => {
        const updated = [...localWaypointValues];
        updated[index] = value;
        setLocalWaypointValues(updated);
    };

    const handlePlaceChanged = (index) => {
        const place = waypointRefs.current[index]?.getPlace();
        if (place?.formatted_address) {
            updateWaypoint(index, place.formatted_address); // update main state
            calculateRoute();
        }
    };
    // end of waypoints

    async function calculateRoute() {

        if (user.subscription < 1) {
            alert(`Your Subscription has been expired. Please recharge`);
            navigate('/driver/payment')
        }

        if (origin === '' || destination === '' || vehicleDvNo === 0) {
            // alert(`Please enter origin & destination`);ss
            toast({
                title: 'Please Enter Vehicle, Origin & Destination',
                status: 'warning',
                duration: 10000, // 10 seconds
                isClosable: true,
                position: 'top-right'
            });
            return;
        }

        // eslint-disable-next-line no-undef
        const directionsService = new google.maps.DirectionsService()

        let waypointLocations = waypoints
            .filter(w => w !== '')
            .map(w => ({ location: w, stopover: true }));

        const results = await directionsService.route({
            origin: origin,
            destination: destination,
            waypoints: waypointLocations,
            travelMode: window.google.maps.TravelMode.DRIVING,
            optimizeWaypoints: false,
            provideRouteAlternatives: true,
        });

        setDirectionsResponse(results)
        setDistance(results.routes[0].legs[0].distance.text)
        setDuration(results.routes[0].legs[0].duration.text)
        setSelectedRouteIndex(0) // default to first route
        setDriveBtn(true)

        const routePath = results.routes[0].overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng()
        }));
        setDriverRoute(routePath); // Store driver route points

        try {
            const originLatLng = await getLatLng(origin);
            const destinationLatLng = await getLatLng(destination);

            // Find nearest user to the origin
            let nearestUser = null;
            let minDistance = Infinity;

            users.forEach((user) => {
                const dist = getDistanceInKm(
                    originLatLng.lat(),
                    originLatLng.lng(),
                    user.lat,
                    user.lng
                );
                if (dist < minDistance) {
                    minDistance = dist;
                    nearestUser = user;
                }
            });

            if (nearestUser) {
                console.log(
                    "Nearest User:",
                    nearestUser.FName,
                    `(${minDistance.toFixed(2)} km)`
                );
            }

            // Save driver location
            // saveDriverLocation();
            setDriver({ lat: originLatLng.lat(), lng: originLatLng.lng(), endLat: destinationLatLng.lat(), endLng: destinationLatLng.lng() });
            setDriverLocation(latestLocationRef.current || { lat: originLatLng.lat(), lng: originLatLng.lng() })
        } catch (error) {
            console.error(error);
        }
    }

    async function calculateRouteWithParam(origin, destination, vehicleDvNo) {

        if (!origin || !destination || !vehicleDvNo) {
            toast({
                title: 'Please Enter Vehicle, Origin & Destination',
                status: 'warning',
                duration: 10000,
                isClosable: true,
                position: 'top-right'
            });
            return;
        }

        const waitForGoogleMaps = () =>
            new Promise((resolve) => {
                const check = () => {
                    if (window.google && window.google.maps && window.google.maps.DirectionsService) {
                        resolve();
                    } else {
                        setTimeout(check, 100); // wait and check again
                    }
                };
                check();
            });

        await waitForGoogleMaps();

        const directionsService = new window.google.maps.DirectionsService();

        let waypointLocations = waypoints
            .filter(w => w !== '')
            .map(w => ({ location: w, stopover: true }));

        const results = await directionsService.route({
            origin: origin,
            destination: destination,
            waypoints: waypointLocations,
            travelMode: window.google.maps.TravelMode.DRIVING,
            optimizeWaypoints: false,
            provideRouteAlternatives: true,
        });

        setDirectionsResponse(results);
        setDistance(results.routes[0].legs[0].distance.text);
        setDuration(results.routes[0].legs[0].duration.text);
        setSelectedRouteIndex(0);

        const routePath = results.routes[0].overview_path.map(point => ({
            lat: point.lat(),
            lng: point.lng()
        }));
        setDriverRoute(routePath);
        //setSearchSection(false);

        try {
            const originLatLng = await getLatLng(origin);
            const destinationLatLng = await getLatLng(destination);

            let nearestUser = null;
            let minDistance = Infinity;

            users.forEach((user) => {
                const dist = getDistanceInKm(
                    originLatLng.lat(),
                    originLatLng.lng(),
                    user.lat,
                    user.lng
                );
                if (dist < minDistance) {
                    minDistance = dist;
                    nearestUser = user;
                }
            });

            if (nearestUser) {
                console.log(
                    "Nearest User:",
                    nearestUser.FName,
                    `(${minDistance.toFixed(2)} km)`
                );
            }

            setDriver({
                lat: originLatLng.lat(),
                lng: originLatLng.lng(),
                endLat: destinationLatLng.lat(),
                endLng: destinationLatLng.lng(),
            });
        } catch (error) {
            console.error(error);
        }
    }


    const saveDriverLocation = async () => {
        const sLatLng = await getLatLng(origin);
        const eLatLng = await getLatLng(destination);

        let driverInfo = user;
        driverInfo.Frmloc = origin;
        driverInfo.Toloc = destination;
        driverInfo.lat = sLatLng.lat();
        driverInfo.lng = sLatLng.lng();
        driverInfo.endLat = eLatLng.lat();
        driverInfo.endLng = eLatLng.lng();
        driverInfo.DVNo = vehicleDvNo;
        driverInfo.VTyp = vehicleType;

        // for hide google map search section
        //setSearchSection(false);
        // setSearchSection(true);

        if (sLatLng.lat()) {
            try {
                const driverData = await DriverService.saveStartLocation(driverInfo);
                console.log("saveDriverLocation", driverData)
                setDriveNo(driverData.DriveNo);
                // session
                // user.DriveNo = driverData.DriveNo;
                // localStorage.setItem("user", JSON.stringify(user));
                setDriverRideDataInStorage({ DriveNo: driverData.DriveNo, trackingComplete: false });

                sendLocationToServer(driverData.DriveNo, sLatLng.lat(), sLatLng.lng());
                setRouteColor("green");

                // START REAL GPS TRACKING
                startLocationTracking();
                // START 1 MIN SYNC
                startLocationSync(driverData.DriveNo);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        } else {
            alert('Please Select Location')
        }
        // moveDriverOnPolyline({
        //     path: driverRoute,
        //     interval: 2000,

        //     onUpdate: (coords) => {
        //         // move marker
        //         setDriverLocation(coords);

        //         // move map
        //         setCenter(coords);
        //     },
        //     onComplete: () => {
        //         console.log("Route Completed");
        //     }
        // });
    }

    function clearRoute() {
        rideStartRequestRef.current++;
        passengersRequestRef.current++;
        setPickupReachedReqs([]);
        setDropReachedReqs([]);
        setOnboardRequests([]);
        clearIntervalAction();
        setDirectionsResponse(null)
        setDistance('')
        setDuration('')
        setSelectedRouteIndex(0)
        setOrigin("")
        setDestination("")
        setDriverRoute([]);
        setPassengerCandidates([]);
        setUsers([]);
        setNearestUser(null);
        setPassengerMarker(null);
        setSelectedRouteIndex(null);
        setDriveBtn(false);
        setRouteColor("blue");
        setDriveNo(0);
        setDriverLocation(null)
        clearDriverRideData()
    }

    function handleSelectRoute(index) {
        if (selectedRouteIndex === index) {
            setSelectedRouteIndex(null); // Deselect if clicked again
        } else {
            setSelectedRouteIndex(index);// Select new route
        }

        const selected = directionsResponse.routes[index]
        setDistance(selected.legs[0].distance.text)
        setDuration(selected.legs[0].duration.text)
    }

    const openDrawerWithData = async (passengerData) => {
        console.log("openDrawerWithData", passengerData)
        setPassengerInfo({
            uId: passengerData.PassengerId,
            Name: `${passengerData.FName} ${passengerData.LName}`,
            MobileNo: passengerData.MobileNo,
            ReqNo: passengerData.ReqNo,
        });

        // session
        // user.PassengerId = passengerData.PassengerId;
        // user.ReqNo = passengerData.ReqNo;
        // user.DriveNo = DriveNo;
        // localStorage.setItem("user", JSON.stringify(user));

        setDriverRideDataInStorage({
            PassengerId: passengerData.PassengerId,
            ReqNo: passengerData.ReqNo,
        });

        if (passengerData.PassengerId) {
            // Drop the previous passenger's chat so ride-step buttons never use stale history.
            setMessages([]);
            getChats(DriveNo, passengerData.PassengerId);
            driverReply(DriveNo, passengerData.PassengerId);
            onOpen();
        }
    }

    const handleOptionSelect = async (rpl, textMsg, rate, callFrom = "") => {
        // console.log(rpl);return false;
        let params = {};
        params.DriveNo = DriveNo;
        params.DriverId = user.uId;
        params.uId = passengerInfo.uId;
        params.MsgId = rpl.MsgId;
        params.Rate = rate;
        params.msg = textMsg;
        params.DStat = Number(rpl.DStat);
        params.PStat = Number(rpl.PStat);
        params.SendBy = user.uId;
        params.MobileNo = passengerInfo.MobileNo;
        // Always target the passenger whose chat is open.
        params.ReqNo = passengerInfo.ReqNo ?? driverRideSession.ReqNo;
        params.authToken = user.authToken

        await UserService.savePassengerReply(params);
        // socketRef.current.emit("send_message", 'Driver reply');

        socketRef.current.emit("send_message", {
            senderId: user.uId,
            receiverId: passengerInfo.uId,
            messageData: {
                ...rpl,
                DriveNo: params.DriveNo,
                ReqNo: params.ReqNo,
            }
        })
        if (rpl.MsgId == 25) {
            clearIntervalAction();
            setDriverRideDataInStorage({ trackingComplete: true });
            openRatingModal()
        }

        getChats(DriveNo, passengerInfo.uId, "handleOptionSelect call getChats");
        driverReply(DriveNo, passengerInfo.uId);
        if (rpl.MsgId == 28) {
            clearIntervalAction();
            clearRoute();
        }
    };

    const handleOTP = async (e) => {
        e.preventDefault();
        setOTPError('')
        let params = {};
        params.DriveNo = DriveNo;
        params.ReqNo = selectedOTPPassenger.ReqNo;

        // Block boarding once every seat is taken.
        if (!onboardRequests.includes(String(selectedOTPPassenger.ReqNo)) && seatsLeft <= 0) {
            setOTPError('Vehicle is full');
            return;
        }

        if (otp) {
            params.otp = otp;
            const otp_res = await DriverService.verifyOTP(params);
            if (otp_res.statusCode === 201 || otp_res.statusCode === 400) {
                console.log(otp_res)
                setOTPError(otp_res.message)
            } else {

                onModalClose();
            }
            if (otp_res.statusCode === 200) {
                try {
                    // Persist the started ride before notifying the passenger;
                    // their socket handler immediately checks the ride status.
                    await afterVerifyingOTPSendMessageToDriverRideAccepted();
                    // An older restore response must not undo this OTP result.
                    rideStartRequestRef.current++;
                    setOnboardRequests(requests => [...new Set([...requests, String(selectedOTPPassenger.ReqNo)])]);
                    await afterVerifyingOTPSendMessageToPassengerAccepted();
                    // testMode: MsgId 15 was just recorded -> simulate from this pickup.
                    if (isTestModeAvailable()) testModeHandleRideAccepted(selectedOTPPassenger, 'OTP verified');
                    startLocationTracking();
                    publishDriverLocation();
                } catch (error) {
                    console.log()
                    console.error(error);
                }
            }
        }
    };
    // By defualt driver send this to passenger
    const afterVerifyingOTPSendMessageToPassengerAccepted = async () => {
        let params = {};
        params.DriveNo = DriveNo;
        params.DriverId = user.uId;
        params.uId = selectedOTPPassenger.PassengerId;
        params.MsgId = 12;
        params.Rate = 0;
        params.msg = "Passenger accepted (OTP)";
        params.DStat = 3;
        params.PStat = 0;
        params.SendBy = user.uId;
        params.MobileNo = selectedOTPPassenger.MobileNo;
        params.ReqNo = selectedOTPPassenger.ReqNo;
        params.authToken = user.authToken

        await UserService.savePassengerReply(params);
        // realtime message to passenger no need this below function because sidebar closed when drawer is open
        socketRef.current.emit("send_message", {
            senderId: user.uId,
            receiverId: selectedOTPPassenger.PassengerId,
            messageData: {
                MsgId: 12,
                msg: "Passenger accepted (OTP)",
                ReqNo: selectedOTPPassenger.ReqNo,
                DriveNo,
            },
        });
    }
    // By defualt passenger send this to driver
    const afterVerifyingOTPSendMessageToDriverRideAccepted = async () => {
        let params = {};
        params.DriveNo = DriveNo;
        params.DriverId = user.uId;
        params.uId = selectedOTPPassenger.PassengerId;
        params.MsgId = 15;
        params.Rate = 0;
        params.msg = "Ride accepted (OTP)";
        params.DStat = 3;
        params.PStat = 0;
        params.SendBy = selectedOTPPassenger.PassengerId;
        params.MobileNo = selectedOTPPassenger.MobileNo;
        params.ReqNo = selectedOTPPassenger.ReqNo;
        params.authToken = user.authToken

        await UserService.savePassengerReply(params);

    }

    // passenger rich and drop 
    const getMatchingRichDropPoint = async (driverPos, passengers, maxDistanceMeters) => {
        return passengers.filter(passenger =>
            isWithinDistance(driverPos, passenger, maxDistanceMeters)
        );
    }

    const isWithinDistance = (driverPos, passengerPos, maxDistanceMeters) => {
        const driverLatLng = new window.google.maps.LatLng(driverPos.lat, driverPos.lng);
        const passengerLatLng = new window.google.maps.LatLng(passengerPos.lat, passengerPos.lng);

        // user.ReqNo = passengerPos.ReqNo;
        // localStorage.setItem("user", JSON.stringify(user));

        setDriverRideDataInStorage({
            ReqNo: passengerPos.ReqNo,
        });

        setPassengerInfo({
            uId: passengerPos.PassengerId,
            Name: `${passengerPos.FName} ${passengerPos.LName}`,
            MobileNo: passengerPos.MobileNo,
            ReqNo: passengerPos.ReqNo,
        });

        const richDistance = window.google.maps.geometry.spherical.computeDistanceBetween(driverLatLng, passengerLatLng);

        // return richDistance <= maxDistanceMeters;
        if (richDistance <= maxDistanceMeters) {
            // rich point
            let rpl = {
                MsgId: 10,
                DStat: 0,
                PStat: 0
            }
            const textMsg = 'Reached pick-up point';
            handleOptionSelect(rpl, textMsg, 0, "isWithinDistance---richDistance");
        }

        const passengerELatLng = new window.google.maps.LatLng(passengerPos.endLat, passengerPos.endLng);
        const dropDistance = window.google.maps.geometry.spherical.computeDistanceBetween(driverLatLng, passengerELatLng);

        // return richDistance <= maxDistanceMeters;
        if (dropDistance <= maxDistanceMeters) {
            // drop point
            let rpl = {
                MsgId: 22,
                DStat: 0,
                PStat: 0
            }
            const textMsg = 'Reached preferred drop-off point';
            handleOptionSelect(rpl, textMsg, 0, "isWithinDistance---dropDistance");
        }
    };

    const handlePassengerSelect = async (passenger) => {
        setPassengerMarker(passenger)

        // Do not paint fixed, unmanaged route segments over the live route.
        if (DriveNo > 0) return;

        const google = window.google;

        // Compute the 4 key points
        const driverStartLatLng = new google.maps.LatLng(driver.lat, driver.lng);
        const driverEndLatLng = new google.maps.LatLng(driver.endLat, driver.endLng);
        const pickupLatLng = new google.maps.LatLng(passenger.lat, passenger.lng);
        const dropLatLng = new google.maps.LatLng(passenger.endLat, passenger.endLng);

        // Draw color-coded route
        renderColorCodedRoutes(
            map,
            driverStartLatLng,
            pickupLatLng,
            dropLatLng,
            driverEndLatLng
        );
    }

    // Ride has started once at least one passenger's OTP is accepted.
    const isRideStarted = DriveNo > 0 && onboardRequests.length > 0;

    const getPassengerPosition = passenger => (
        onboardRequests.includes(String(passenger.ReqNo)) && driverLocation
            ? driverLocation
            : { lat: Number(passenger.lat), lng: Number(passenger.lng) }
    );

    // Seat capacity of the selected vehicle (bike = 1, car = maxSeat).
    const seatCapacity = getSeatCapacity(
        vehicleList.find(vehicle => String(vehicle.DVNo) === String(vehicleDvNo)),
        vehicleType
    );
    const seatsLeft = Math.max(0, seatCapacity - onboardRequests.length);

    // Show onboard passengers plus as many waiting passengers as seats remain.
    const visiblePassengers = limitPassengersToSeats(users, onboardRequests, seatCapacity, driverLocation || driver);

    // Spread passengers sharing a position (same pickup, or onboard with the
    // vehicle) side by side so every passenger stays visible and clickable.
    const passengerOffsets = getSideBySideOffsets(
        visiblePassengers,
        getPassengerPosition,
        passenger => passenger.ReqNo
    );

    const getPassengerOffset = passenger => passengerOffsets.get(String(passenger.ReqNo)) ?? 28;

    function renderColorCodedRoutes(map, driverStart, pickup, drop, driverEnd) {
        const google = window.google;

        // Compute distances
        const distPickupToDrop = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(pickup),
            new google.maps.LatLng(drop)
        );
        const distPickupToDriverEnd = google.maps.geometry.spherical.computeDistanceBetween(
            new google.maps.LatLng(pickup),
            new google.maps.LatLng(driverEnd)
        );

        const renderSegment = (origin, destination, color) => {
            const directionsService = new google.maps.DirectionsService();
            directionsService.route({
                origin,
                destination,
                travelMode: google.maps.TravelMode.DRIVING
            }, (result, status) => {
                if (status === "OK") {
                    new google.maps.DirectionsRenderer({
                        map,
                        directions: result,
                        suppressMarkers: true,
                        polylineOptions: {
                            strokeColor: color,
                            strokeWeight: 5,
                        },
                    });
                } else {
                    console.error("Directions request failed:", status);
                }
            });
        };

        //  Blue: driverStart to pickup
        renderSegment(driverStart, pickup, "#0000FF");

        //  Green: pickup to earlier of driverEnd or drop
        const greenEnd = distPickupToDriverEnd < distPickupToDrop ? driverEnd : drop;
        renderSegment(pickup, greenEnd, "#00FF00");

        //  Orange: driver ends before passenger drop
        // Add a small buffer to treat near-equal as equal
        const EPSILON = 20; // meters

        if (distPickupToDriverEnd + EPSILON < distPickupToDrop) {
            console.log("Driver ends before passenger. Rendering orange route.");
            renderSegment(driverEnd, drop, "#FFA500"); // Orange
        } else if (distPickupToDriverEnd > distPickupToDrop + EPSILON) {
            console.log("Driver continues beyond passenger. Rendering yellow route.");
            renderSegment(drop, driverEnd, "#FFFF00"); // Yellow
        } else {
            console.log("Driver and passenger end points are roughly the same. No orange/yellow needed.");
        }

        //  Yellow: driver goes beyond drop
        if (distPickupToDriverEnd > distPickupToDrop) {
            renderSegment(drop, driverEnd, "#FFFF00");
        }
    }

    const getVehicleIcon = (type) => {
        type = Number(type)
        switch (type) {
            case 2:
                return '/assets/images/bike.png';
            case 4:
            case 6:
            case 7:
                return '/assets/images/car.png';
            default:
                return 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'; // fallback icon
        }
    };

    // Pick-up / drop-off notices go only to the passenger whose chat is open.
    // Flow per passenger: "OK, pick me up" -> pick-up (10) ... "Ride accepted (OTP)" (15) -> drop-off (22).
    const currentReqNo = passengerInfo.ReqNo != null ? String(passengerInfo.ReqNo) : null;
    const chatHas = (msgId, text) => Array.isArray(messages) && messages.some(item =>
        getTestModeChatMsgId(item) === msgId || (text && String(item?.msg || '').trim() === text));
    // Passenger confirmed pick-up ("OK, pick me up"), matched on text since its MsgId comes from the reply table.
    const isPickMeUpForCurrent = currentReqNo != null && Array.isArray(messages) && messages.some(item =>
        String(item?.SendBy) === String(passengerInfo.uId) && /pick\s*me\s*up/i.test(String(item?.msg || '')));
    const isRideAcceptedForCurrent = currentReqNo != null &&
        (onboardRequests.includes(currentReqNo) || chatHas(15, 'Ride accepted (OTP)'));
    const isPickupSentForCurrent = currentReqNo != null &&
        (pickupReachedReqs.includes(currentReqNo) || chatHas(10, 'Reached pick-up point'));
    const isDropSentForCurrent = currentReqNo != null &&
        (dropReachedReqs.includes(currentReqNo) || chatHas(22, 'Reached preferred drop-off point'));
    // Both buttons stay in the chat sidebar for the ride; each is clickable only at its step.
    const showPickupButton = DriveNo > 0 && currentReqNo != null && !isPickupSentForCurrent;
    const showDropButton = DriveNo > 0 && currentReqNo != null && !isDropSentForCurrent;
    const canSendPickup = isPickMeUpForCurrent || isRideAcceptedForCurrent;
    const canSendDrop = isRideAcceptedForCurrent;
    const rideStepHint = showPickupButton && !canSendPickup
        ? 'Waiting for "OK, pick me up"'
        : showDropButton && !canSendDrop ? 'Rich to destination unlocks after "Ride accepted (OTP)"' : '';

    const handlePickUpPoint = async () => {
        if (currentReqNo == null || !canSendPickup) return;
        let rpl = {
            MsgId: 10,
            DStat: 0,
            PStat: 0
        }
        const textMsg = 'Reached pick-up point';
        await handleOptionSelect(rpl, textMsg, 0, "drawer---pickup");
        const next = [...new Set([...pickupReachedReqs, currentReqNo])];
        setPickupReachedReqs(next);
        setDriverRideDataInStorage({ pickupReachedReqs: next });
    }

    const handleRichPoint = async () => {
        if (currentReqNo == null || !canSendDrop) return;
        let rpl = {
            MsgId: 22,
            DStat: 0,
            PStat: 0
        }
        const textMsg = 'Reached preferred drop-off point';
        await handleOptionSelect(rpl, textMsg, 0, "drawer---drop");
        const next = [...new Set([...dropReachedReqs, currentReqNo])];
        setDropReachedReqs(next);
        setDriverRideDataInStorage({ dropReachedReqs: next });
    }

    const openRatingModal = () => {
        setIsRatingModalOpen(true);
    };

    const closeRatingModal = () => {
        setIsRatingModalOpen(false);
        completeDriverRide()
        clearRoute();
    };

    return (
        <DriverLayout>
            <Flex
                position='relative'
                flexDirection='column'
                alignItems='center'
                h='100vh'
                w='100vw'
                overflow='hidden'
            >
                {/* <div className='complete-ride-btn'>
                    <IconButton
                        aria-label="Waypoint"
                        icon={<FaCheckCircle />}
                        colorScheme="green"
                        onClick={completeDriverRide} size="sm"
                    />
                </div> */}
                <Box position='absolute' left={0} top={0} h='100%' w='100%' overflow="hidden">
                    <GoogleMap
                        center={center}
                        zoom={15}
                        mapContainerStyle={{ width: '100%', height: '100%' }}
                        options={{
                            zoomControl: false,
                            streetViewControl: false,
                            mapTypeControl: false,
                            fullscreenControl: false,
                        }}
                        onLoad={map => setMap(map)}
                    >
                        {/** driver*/}

                        {driverLocation && (
                            <Marker
                                position={driverLocation}
                                // label="Driver"
                                icon={{
                                    url: getVehicleIcon(vehicleType),
                                    scaledSize: new window.google.maps.Size(40, 40),
                                }}
                                onClick={() => setDriverMarker(driverLocation)}

                            />
                        )}

                        {directionsResponse && (
                            <>
                                {/* Render Selected Route using DirectionsRenderer */}
                                <DirectionsRenderer
                                    directions={selectedDirections}
                                    options={{
                                        suppressMarkers: true,
                                        suppressPolylines: DriveNo > 0,
                                        polylineOptions: {
                                            strokeColor: routeColor,
                                            strokeOpacity: 0.8,
                                            strokeWeight: 5,
                                        },
                                        // preserveViewport: true,
                                    }}
                                />
                                {DriveNo > 0 && (
                                    <RemainingRoute
                                        key={DriveNo}
                                        route={directionsResponse.routes[selectedRouteIndex]}
                                        location={driverLocation}
                                        color={routeColor}
                                    />
                                )}
                                <RouteMarkers
                                    route={directionsResponse.routes[selectedRouteIndex]}
                                    liveOrigin={DriveNo > 0 ? driverLocation : null}
                                />

                                {/* Render Alternative Routes using Polyline */}
                                {DriveNo <= 0 && directionsResponse.routes.map((route, idx) =>
                                    idx !== selectedRouteIndex ? (
                                        <Polyline
                                            key={idx}
                                            path={route.overview_path.map((point) => ({
                                                lat: point.lat(),
                                                lng: point.lng(),
                                            }))}
                                            options={{
                                                strokeColor: idx === selectedRouteIndex ? routeColor : "gray",
                                                strokeOpacity: 0.6,
                                                strokeWeight: idx === selectedRouteIndex ? 5 : 4,
                                                zIndex: idx === selectedRouteIndex ? 2 : 1, // Bring selected route to front
                                            }}
                                            onClick={() => handleSelectRoute(idx)}
                                        />
                                    ) : null
                                )}
                            </>
                        )}
                        {visiblePassengers.map((user, index) => {
                                const isUserOnSelectedRoute = checkUserOnRoute(user, directionsResponse?.routes[selectedRouteIndex]);

                                return (
                                    <Marker
                                        key={user.ReqNo}
                                        position={getPassengerPosition(user)}
                                        title={`Passenger: ${user.FName || ''} ${user.LName || ''}`.trim()}
                                        zIndex={2000 + index}
                                        icon={{
                                            url: isUserOnSelectedRoute
                                                ? "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                                : "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
                                            scaledSize: new window.google.maps.Size(40, 40),
                                            // Keep the passenger beside A/the bike when coordinates coincide.
                                            anchor: new window.google.maps.Point(20 - getPassengerOffset(user), 40),
                                        }}
                                        onClick={() => handlePassengerSelect(user)}
                                    />
                                );
                            })}

                        {nearestUser && (
                            <Marker
                                position={{ lat: nearestUser.lat, lng: nearestUser.lng }}
                                label="Nearest"
                                icon={{
                                    url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                                }}
                            />
                        )}

                        {passengerMarker && visiblePassengers.some(passenger => String(passenger.ReqNo) === String(passengerMarker.ReqNo)) && (
                            <InfoWindow
                                position={getPassengerPosition(passengerMarker)}
                                onCloseClick={() => setPassengerMarker(null)}
                                options={{ pixelOffset: new window.google.maps.Size(getPassengerOffset(passengerMarker), -40) }}
                            >
                                <Box p={3} borderRadius="md" bg="white" boxShadow="lg" minW="220px">
                                    {/* Profile Section */}
                                    <Flex align="center" mb={2}>
                                        <Avatar
                                            src={`${backendUrl}/profile/${passengerMarker.ProfilePic}`}
                                            name={`${passengerMarker.FName} ${passengerMarker.LName}`}
                                            size="md"
                                            mr={3}
                                        />
                                        <Box>
                                            <Text fontWeight="bold" fontSize="sm">
                                                {passengerMarker.FName} {passengerMarker.LName}
                                            </Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Age: {calculateAge(passengerMarker.DOB)}, ( {getGender(passengerMarker.Gender)} )
                                            </Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Max Rate: {passengerMarker.maxAmt}
                                            </Text>
                                            <Text fontSize="sm">
                                                📍 <strong>Trip count:</strong> {passengerMarker?.completedRideCount || 0}
                                            </Text>
                                            <Text fontSize="sm">
                                                ⭐<strong>Ratings:</strong> {passengerMarker?.rating?.Passenger || 0}
                                            </Text>
                                        </Box>
                                    </Flex>

                                    {/* Premium Features */}
                                    {passengerMarker.Premium > 0 && (
                                        <>
                                            <Divider my={2} />
                                            <Box>
                                                <Text fontSize="sm">🎵 <strong>Music:</strong> {getMusic(passengerMarker.Music)}</Text>
                                                <Text fontSize="sm">🍔 <strong>Eat:</strong> Allowed</Text>
                                                <Text fontSize="sm">🚬 <strong>Smoking:</strong> Allowed</Text>
                                                <Text fontSize="sm">⏱️ <strong>ETA:</strong> 10 mins</Text>
                                            </Box>
                                        </>
                                    )}

                                    {/* Chat Button */}
                                    <Box>
                                        <IconButton
                                            aria-label='Chat'
                                            icon={<FaRocketchat />}
                                            ref={btnRef} size='xs'
                                            colorScheme='teal' onClick={() => openDrawerWithData(passengerMarker)}
                                            w='100%'
                                        />
                                        <IconButton
                                            aria-label='center back'
                                            icon={<FaMobile />}
                                            size='xs' colorScheme='red' mt={1}
                                            onClick={() => {
                                                setSelectedOTPPassenger(passengerMarker);
                                                onModalOpen(); // open the modal
                                            }}
                                            w='100%'
                                        />
                                    </Box>
                                </Box>
                            </InfoWindow>
                        )}

                        {driverMarker && (
                            <InfoWindow
                                position={driverLocation || driverMarker}
                                onCloseClick={() => setDriverMarker(null)}
                                options={{ pixelOffset: new window.google.maps.Size(0, -30) }}
                            >
                                <Box
                                    p={3}
                                    borderRadius="md"
                                    bg="white"
                                    boxShadow="lg"
                                    minW={{ base: "100%", sm: "220px" }} // full width on small screens
                                    maxW={{ base: "100%", sm: "300px" }} // optional: limit width on small screens
                                >
                                    {/* Profile Section */}
                                    <Flex align="center" justify="flex-start" mb={2}>
                                        <Avatar
                                            src={`${backendUrl}/profile/${user.ProfilePic}`}
                                            name={`${user.FName} ${user.LName}`}
                                            size="md"
                                            mr={3}
                                        />
                                        <Box>
                                            <Text fontWeight="bold" fontSize="md">
                                                {user.FName} {user.LName}
                                            </Text>
                                            <Text fontSize="sm" color="gray.600">
                                                Age: {calculateAge(user.DOB)}, ({getGender(user.Gender)})
                                            </Text>
                                        </Box>
                                    </Flex>

                                    <Divider my={2} />

                                    {user.Premium > 0 && (
                                        <>
                                            <Divider my={2} />

                                            {/* Premium Features */}
                                            <Box>
                                                <Text fontSize="sm">🎵 <strong>Music:</strong> {getMusic(user.Music)}</Text>
                                                <Text fontSize="sm">🍔 <strong>Eat:</strong> Allowed</Text>
                                                <Text fontSize="sm">🚬 <strong>Smoking:</strong> Allowed</Text>
                                                <Text fontSize="sm">⏱️ <strong>ETA:</strong> 10 mins</Text>
                                            </Box>
                                        </>
                                    )}

                                </Box>

                            </InfoWindow>
                        )}

                    </GoogleMap>
                </Box>
                {searchSection && (
                    <Box
                        p={4}
                        borderRadius="lg"
                        m={4}
                        bgColor="white"
                        shadow="base"
                        minW={{ base: '100%', md: 'container.md' }}
                        zIndex="1"
                    >
                        {/* Ride started (OTP accepted): pick-up / drop-off live in each passenger's chat */}
                        {isRideStarted && (
                            <Text fontSize="sm" color="gray.600">
                                Open a passenger's chat to send pick-up / drop-off updates.
                            </Text>
                        )}

                        {/* Top row: Inputs + Buttons (hidden once the ride has started) */}
                        {!isRideStarted && (
                        <Stack
                            direction={{ base: 'column', md: 'row' }}
                            spacing={2}
                            justifyContent="space-between"
                        >
                            <Box flexGrow={1}>

                                <Select size="sm" value={vehicleDvNo} onChange={handleVehicle}>
                                    <option value=''>Select Vehicle </option>
                                    {
                                        vehicleList.map((val) => (
                                            <option key={val.DVNo}
                                                value={val.DVNo}
                                                data-type={val.VTyp}>{val.VMake} {val.VNo}</option>
                                        ))}
                                </Select>

                            </Box>
                            <Box flexGrow={1}>
                                <Autocomplete
                                    onLoad={(autocomplete) => (originRef.current = autocomplete)}
                                    onPlaceChanged={handleOrigin}
                                >
                                    <Input type="text" placeholder="Origin" size="sm" value={origin}
                                        onChange={(e) => setOrigin(e.target.value)} />
                                </Autocomplete>
                            </Box>

                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="waypoints">
                                    {(provided) => (
                                        <VStack
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            spacing={3}
                                            align="stretch"
                                        >
                                            {waypoints.map((waypoint, index) => (
                                                <Draggable key={index} draggableId={`waypoint-${index}`} index={index}>
                                                    {(provided) => (
                                                        <HStack
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            spacing={2}
                                                        >
                                                            <Box {...provided.dragHandleProps} cursor="grab" p={2}>
                                                                <FaGripVertical />
                                                            </Box>

                                                            <Autocomplete
                                                                onLoad={(autocomplete) => (waypointRefs.current[index] = autocomplete)}
                                                                onPlaceChanged={() => handlePlaceChanged(index)}
                                                            >
                                                                <input
                                                                    value={localWaypointValues[index] || ""}
                                                                    onChange={(e) => handleInputChange(index, e.target.value)}
                                                                    placeholder={`Waypoint ${index + 1}`}
                                                                    style={{
                                                                        flex: 1,
                                                                        padding: '6px',
                                                                        borderRadius: '4px',
                                                                        border: '1px solid #ccc',
                                                                    }}
                                                                />
                                                            </Autocomplete>

                                                            <IconButton
                                                                aria-label="Remove waypoint"
                                                                icon={<FaTimes />}
                                                                onClick={() => removeWaypoint(index)}
                                                                size="sm"
                                                                colorScheme="red"
                                                            />

                                                        </HStack>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </VStack>
                                    )}
                                </Droppable>
                            </DragDropContext>

                            <Box flexGrow={1}>
                                <Autocomplete
                                    onLoad={(autocomplete) => (destinationRef.current = autocomplete)}
                                    onPlaceChanged={handleDestination}
                                >
                                    <Input type="text" placeholder="Destination" size="sm" value={destination}
                                        onChange={(e) => setDestination(e.target.value)} />
                                </Autocomplete>
                            </Box>

                            <ButtonGroup display="flex" justifyContent="center" flexWrap="wrap">
                                <IconButton
                                    aria-label="Waypoint"
                                    icon={<FaPlus />}
                                    colorScheme="blue"
                                    onClick={addWaypoint} size="sm"
                                />

                                <IconButton
                                    aria-label="Search"
                                    icon={<FaSearch />}
                                    colorScheme="pink"
                                    onClick={calculateRoute} size="sm"
                                />
                                <IconButton
                                    aria-label="Clear"
                                    icon={<FaTimes />}
                                    onClick={clearRoute} size="sm"
                                />

                                {driveBtn && (
                                    <IconButton
                                        aria-label="Start Drive"
                                        colorScheme="green"
                                        icon={<FaCar />}
                                        onClick={saveDriverLocation} size="sm"
                                    />
                                )}

                                <IconButton
                                    aria-label="Recenter Map"
                                    icon={<FaLocationArrow />}
                                    isRound
                                    onClick={() => {
                                        if (map) {
                                            map.panTo(center);
                                        }
                                        map.setZoom(15);
                                    }}
                                    size="sm"
                                />
                            </ButtonGroup>
                        </Stack>
                        )}

                        {/* Bottom row: Distance + Duration + Recenter */}
                        <Stack
                            direction='row'
                            spacing={4}
                            mt={4}
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Text>Distance: {distance}</Text>
                            <Text>Duration: {duration}</Text>
                        </Stack>
                    </Box>
                )}

                <RefreshPageButton />

                <Drawer
                    isOpen={isOpen}
                    placement='right'
                    onClose={onClose}
                    finalFocusRef={btnRef}
                >
                    <DrawerOverlay />
                    <DrawerContent>
                        <DrawerCloseButton />
                        <DrawerHeader borderBottomWidth='1px'>Chat with {passengerInfo.Name}</DrawerHeader>

                        <DrawerBody>
                            <Stack spacing='24px'>
                                <Box>
                                    <VStack spacing={3} align="stretch" minHeight="300px" overflowY="auto">
                                        {messages.map((item, index) => (
                                            <Text
                                                key={index}
                                                bg={item.SendBy === user.uId ? "blue.200" : "gray.200"}
                                                alignSelf={item.SendBy === user.uId ? "flex-end" : "flex-start"}
                                                p={2}
                                                borderRadius="md"
                                            >
                                                {item.msg}
                                            </Text>
                                        ))}
                                    </VStack>
                                </Box>
                            </Stack>
                        </DrawerBody>

                        <DrawerFooter>
                            <Box textAlign="right" w="100%">
                                {(showPickupButton || showDropButton) && (
                                    <Box mb={2}>
                                        <HStack spacing={2} justify="flex-end">
                                            {showPickupButton && (
                                                <Button size="sm" bg="pink.300" _hover={{ bg: "pink.400" }}
                                                    onClick={handlePickUpPoint}
                                                    isDisabled={!canSendPickup}>
                                                    Rich to pick point
                                                </Button>
                                            )}
                                            {showDropButton && (
                                                <Button size="sm" colorScheme="green"
                                                    onClick={handleRichPoint}
                                                    isDisabled={!canSendDrop}>
                                                    Rich to destination
                                                </Button>
                                            )}
                                        </HStack>
                                        {rideStepHint && (
                                            <Text fontSize="xs" color="gray.500" mt={1}>{rideStepHint}</Text>
                                        )}
                                    </Box>
                                )}
                                <VStack mt={3} spacing={3}>
                                    {reply.filter(item => ![10, 22].includes(Number(item.MsgId))).map((item, index) => {
                                        let textMsg = item.Msg;

                                        // TStat == 0: Show only badge
                                        if (item.TStat === 0 || item.MsgId == 20 || item.MsgId == 22) {
                                            return (
                                                <WrapItem key={`reply-${index}`}>
                                                    <Button
                                                        onClick={() => handleOptionSelect(item, textMsg, amount, "call from button")}
                                                        colorScheme="yellow"
                                                        cursor="pointer"
                                                        size="xs"
                                                        px={3}
                                                        whiteSpace="normal"
                                                    >
                                                        {textMsg}
                                                    </Button>
                                                </WrapItem>
                                            );
                                        }

                                        // TStat != 0: Show input + badge
                                        return (
                                            <HStack key={`reply-input-${index}`} spacing={2}>

                                                <WrapItem>
                                                    <Button
                                                        onClick={() => handleOptionSelect(item, `${textMsg} ${amount}`, amount, "call from button")}
                                                        colorScheme="yellow"
                                                        isDisabled={!amount}
                                                        cursor="pointer"
                                                        size="xs"
                                                        whiteSpace="normal"
                                                    >
                                                        {textMsg} {amount}
                                                    </Button>
                                                </WrapItem>
                                                <Input
                                                    type="number"
                                                    placeholder="Amount"
                                                    value={amount}
                                                    size="xs"
                                                    width="60px"
                                                    onChange={(e) => setAmount(e.target.value)}
                                                />

                                            </HStack>
                                        );
                                    })}
                                </VStack>
                            </Box>
                        </DrawerFooter>
                    </DrawerContent>
                </Drawer>

                {/* OTP Modal */}
                <Modal isOpen={isModalOpen} onClose={onModalClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Verify OTP</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <form onSubmit={handleOTP}>
                                <FormControl isRequired>
                                    <FormLabel>OTP</FormLabel>
                                    <Input
                                        type="number"
                                        name="otp"
                                        placeholder="otp"
                                        value={otp}
                                        maxLength={4}
                                        onChange={(e) => setOTP(e.target.value)}
                                    />
                                </FormControl>

                                <Button colorScheme="teal" type="submit" width="full">Verify</Button>
                                <span className='text-error'>{otpError}</span>
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={onModalClose}>Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
                <PassengerRatingModal
                    isOpen={isRatingModalOpen}
                    onClose={closeRatingModal}
                    DriveNo={DriveNo}
                    DriverID={user.uId}
                    PassengerID={passengerInfo.uId}
                />
            </Flex >
        </DriverLayout>
    );
}

export default DriverMapWithDirections;
